import React, { type ComponentProps } from 'react';
import { Platform, StyleSheet } from 'react-native';
import { type Edges, SafeAreaView } from 'react-native-safe-area-context';

import { Footer } from '@expo/html-elements';
import { theme } from '@garnish/constants';

export const ScanAtCheckoutFooter = (props: ScanAtCheckoutFooterProps) => {
  const { children } = props;

  return (
    <Footer style={styles.container}>
      <SafeAreaView edges={SAFE_AREA_EDGES} style={styles.innerContainer}>
        {children}
      </SafeAreaView>
    </Footer>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const SAFE_AREA_EDGES: Edges = Platform.select({
  android: ['bottom'],
  default: [],
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.colors['GREEN_1.5'],
    paddingTop: theme.spacing['6'],
    paddingHorizontal: theme.spacing['6'],
    paddingBottom: theme.spacing['10'],
  },
  innerContainer: {
    flex: 1,
    alignItems: 'center',
    gap: theme.spacing['6'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ScanAtCheckoutFooterProps = ComponentProps<typeof Footer>;
